import { motion } from "framer-motion";
import { CLINIC } from "@/lib/assets";

const ease = [0.76, 0, 0.24, 1];

export const CareFlow = () => {
    return (
        <section
            className="py-24 md:py-36 px-6 md:px-10 bg-surya-surface relative z-[2]"
            data-testid="careflow-section"
        >
            <div className="mx-auto max-w-[1600px]">
                <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20 items-end">
                    <div className="col-span-12 md:col-span-6">
                        <div className="label text-surya-orange mb-4">
                            How it works
                        </div>
                        <h2 className="font-serif text-surya-ink text-[clamp(2rem,4.5vw,4rem)] leading-[0.95] tracking-[-0.02em] font-light">
                            Three quiet steps from{" "}
                            <span className="italic-display text-surya-orange">
                                first hello
                            </span>{" "}
                            to full recovery.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-5 md:col-start-8">
                        <p className="text-surya-muted text-sm md:text-base leading-relaxed">
                            No production-line dentistry. Every case moves at
                            the pace of your body — not the clock. Below is the
                            rhythm we&apos;ve honed across a decade of practice.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {CLINIC.careFlow.map((c, i) => (
                        <motion.div
                            key={c.step}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-8%" }}
                            transition={{ duration: 0.9, delay: i * 0.1, ease }}
                            className="relative bg-surya-bg border border-surya-line p-8 md:p-10 flex flex-col justify-between min-h-[280px] group"
                            data-testid={`careflow-step-${c.step}`}
                        >
                            <div className="flex items-start justify-between">
                                <span className="chapter-num text-2xl md:text-3xl text-surya-orange">
                                    /{c.step}
                                </span>
                                <div className="h-px flex-1 ml-6 bg-surya-line self-center" />
                            </div>
                            <div className="mt-10">
                                <h3 className="font-serif text-surya-ink text-3xl md:text-4xl font-light leading-none">
                                    {c.title}
                                    <span className="text-surya-orange">.</span>
                                </h3>
                                <p className="mt-5 text-surya-muted text-sm md:text-base leading-relaxed">
                                    {c.body}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
